/* ============================================
   SMITH'S BLADES — WISHLIST ENGINE
   localStorage + Quick View + Notifications
   ============================================ */

(function () {
  'use strict';

  var STORAGE_KEY = 'smiths-blades-wishlist';
  var MAX_ITEMS   = 50;

  /* ═══════════════════════════════════════
     STORAGE LAYER
     ═══════════════════════════════════════ */
  var Store = {
    get: function () {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) { return []; }
    },
    save: function (items) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS))); }
      catch (e) { /* quota exceeded */ }
    },
    add: function (handle) {
      var items = this.get();
      if (items.indexOf(handle) !== -1) return items;
      items.unshift(handle);
      if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
      this.save(items);
      this.emit('added', handle);
      this.emit('changed', items);
      return items;
    },
    remove: function (handle) {
      var items = this.get().filter(function (h) { return h !== handle; });
      this.save(items);
      this.emit('removed', handle);
      this.emit('changed', items);
      return items;
    },
    has: function (handle) {
      return this.get().indexOf(handle) !== -1;
    },
    count: function () {
      return this.get().length;
    },
    clear: function () {
      this.save([]);
      this.emit('changed', []);
    },
    emit: function (type, data) {
      document.dispatchEvent(new CustomEvent('smiths:wishlist:' + type, {
        detail: { handle: data, items: this.get() },
        bubbles: true
      }));
    }
  };

  /* ═══════════════════════════════════════
     MIGRATION — remove old product IDs
     collection.js used to store numeric IDs
     in the same key. Clean them out.
     ═══════════════════════════════════════ */
  function migrateStorage() {
    var items = Store.get();
    var cleaned = items.filter(function (item) {
      /* Handles contain letters/hyphens; IDs are purely numeric */
      return typeof item === 'string' && !/^\d+$/.test(item);
    });
    if (cleaned.length !== items.length) {
      Store.save(cleaned);
    }
  }

  /* ═══════════════════════════════════════
     MONEY FORMATTER
     ═══════════════════════════════════════ */
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    var fmt = (window.SmithsBlades && SmithsBlades.moneyFormat) || '${{amount}}';
    var val = (cents / 100).toFixed(2);
    return fmt.replace('{{amount}}', val)
              .replace('{{amount_no_decimals}}', String(Math.floor(cents / 100)))
              .replace('{{amount_with_comma_separator}}', val.replace('.', ','));
  }

  /* ═══════════════════════════════════════
     BUTTON INIT
     ═══════════════════════════════════════ */
  function initButtons() {
    var handles = Store.get();
    document.querySelectorAll('.wishlist-toggle').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      if (!handle) return;
      if (handles.indexOf(handle) !== -1) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
    updateLabels();
    updateBadge();
  }

  /* ═══════════════════════════════════════
     HEADER BADGE
     ═══════════════════════════════════════ */
  function updateBadge() {
    var count = Store.count();
    document.querySelectorAll('.wishlist-badge').forEach(function (badge) {
      if (count > 0) {
        badge.textContent = count > 99 ? '99+' : count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  /* ═══════════════════════════════════════
     TEXT LABELS
     ═══════════════════════════════════════ */
  function updateLabels() {
    document.querySelectorAll('.wishlist-toggle .wishlist-label').forEach(function (label) {
      var btn    = label.closest('.wishlist-toggle');
      var handle = btn ? btn.getAttribute('data-wishlist-handle') : '';
      label.textContent = (handle && Store.has(handle)) ? 'Saved to Wishlist' : 'Add to Wishlist';
    });
  }

  /* ═══════════════════════════════════════
     NOTIFICATION
     ═══════════════════════════════════════ */
  var notifTimer = null;

  function showNotification(message, isRemoved) {
    var existing = document.getElementById('wishlistNotification');
    if (existing) existing.remove();
    clearTimeout(notifTimer);

    var el = document.createElement('div');
    el.id = 'wishlistNotification';
    el.className = 'wishlist-notification' + (isRemoved ? ' is-removed' : '');

    var iconClass = isRemoved ? 'is-removed' : 'is-added';

    el.innerHTML =
      '<span class="wishlist-notif-icon ' + iconClass + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
          '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/>' +
        '</svg>' +
      '</span>' +
      '<span class="wishlist-notif-text">' + message + '</span>' +
      '<a href="/pages/wishlist" class="wishlist-notif-link">View Wishlist</a>';

    document.body.appendChild(el);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-visible');
      });
    });

    notifTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 350);
    }, 3000);
  }

  /* ═══════════════════════════════════════
     WISHLIST TOGGLE CLICK
     ═══════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-toggle');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;

    var isInWishlist = Store.has(handle);

    if (isInWishlist) {
      Store.remove(handle);
      btn.classList.remove('is-active');
      btn.classList.remove('is-animating');
      btn.setAttribute('aria-label', 'Add to wishlist');
      showNotification('Removed from Wishlist', true);

      var card = btn.closest('.product-card');
      var grid = document.getElementById('wishlistGrid');
      if (card && grid && grid.contains(card)) {
        card.classList.add('is-removing');
        setTimeout(function () {
          card.remove();
          checkWishlistEmpty();
        }, 400);
      }

    } else {
      Store.add(handle);
      btn.classList.add('is-active');
      btn.classList.add('is-animating');
      btn.setAttribute('aria-label', 'Remove from wishlist');
      showNotification('Added to Wishlist', false);

      setTimeout(function () {
        btn.classList.remove('is-animating');
      }, 600);
    }

    updateBadge();
    updateLabels();
  });

  /* ═══════════════════════════════════════
     QUICK VIEW — WISHLIST PAGE SUPPORT
     Uses the EXACT same modal IDs that
     quick-view-modal.liquid renders:
       #quickViewOverlay
       #quickViewModal
       #quickViewClose
       #quickViewContent
     Only activates when collection.js hasn't
     already set up window.openQuickView.
     ═══════════════════════════════════════ */
  var _qvCloseSetup = false;

  function initQuickViewSupport() {
    /* If collection.js already set this up, skip */
    if (window.openQuickView) return;

    var overlay  = document.getElementById('quickViewOverlay');
    var modal    = document.getElementById('quickViewModal');
    var closeBtn = document.getElementById('quickViewClose');
    var content  = document.getElementById('quickViewContent');

    /* Modal markup not present on page */
    if (!overlay || !content) return;

    /* ——— OPEN ——— */
    function openQV(productHandle) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';

      content.innerHTML =
        '<div class="quick-view-loading" style="display:flex;align-items:center;justify-content:center;min-height:300px;padding:3rem;">' +
          '<div style="width:28px;height:28px;border:2px solid rgba(201,168,76,0.15);border-top-color:#C9A84C;border-radius:50%;animation:wishlistSpin 0.8s linear infinite;"></div>' +
        '</div>';

      fetch('/products/' + productHandle + '?view=quick-view')
        .then(function (res) {
          if (!res.ok) throw new Error('Fetch failed');
          return res.text();
        })
        .then(function (html) {
          content.innerHTML = html;
          initQVFeatures();
          /* Re-init wishlist buttons injected into modal */
          setTimeout(initButtons, 80);
        })
        .catch(function () {
          /* Fallback: navigate to product page */
          closeQV();
          window.location.href = '/products/' + productHandle;
        });
    }

    /* ——— CLOSE ——— */
    function closeQV() {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      setTimeout(function () {
        content.innerHTML = '';
      }, 300);
    }

    /* Expose globally — same as collection.js does */
    window.openQuickView = openQV;

    /* ——— CLOSE HANDLERS (set up once) ——— */
    if (_qvCloseSetup) return;
    _qvCloseSetup = true;

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeQV();
      });
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closeQV();
      }
    });

    if (modal) {
      modal.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        closeQV();
      }
    });
  }

  /* ——— QUICK VIEW FEATURES ——— */
  function initQVFeatures() {
    /* Thumbnails */
    var thumbs  = document.querySelectorAll('.qv-thumb');
    var mainImg = document.getElementById('qvMainImage');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        if (mainImg) mainImg.src = this.dataset.imageUrl;
      });
    });

    /* Quantity */
    var qtyBtns  = document.querySelectorAll('.qv-qty-btn');
    var qtyInput = document.getElementById('qvQuantity');
    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = this.dataset.action;
        var value  = parseInt(qtyInput.value) || 1;
        if (action === 'increase') value++;
        else if (action === 'decrease' && value > 1) value--;
        qtyInput.value = value;
      });
    });

    /* Variant selector */
    var variantSelect = document.getElementById('qvVariantSelect');
    var priceEl       = document.querySelector('.qv-price, .qv-price-sale');
    var variantIdEl   = document.getElementById('qvVariantId');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = this.options[this.selectedIndex];
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (variantIdEl) variantIdEl.value = this.value;
      });
    }

    /* Add to Cart */
    var form = document.getElementById('quickViewForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData   = new FormData(this);
        var submitBtn  = this.querySelector('.qv-add-to-cart');
        var origHTML   = submitBtn ? submitBtn.innerHTML : 'Add to Cart';

        if (submitBtn) {
          submitBtn.disabled  = true;
          submitBtn.innerHTML = 'Adding...';
        }

        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (res) { return res.json(); })
          .then(function () {
            if (submitBtn) {
              submitBtn.innerHTML =
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> Added to Cart!';
            }
            showNotification('Product added to cart!', false);
            updateCartCount();
            setTimeout(function () {
              if (submitBtn) {
                submitBtn.disabled  = false;
                submitBtn.innerHTML = origHTML;
              }
            }, 2000);
          })
          .catch(function () {
            if (submitBtn) {
              submitBtn.disabled  = false;
              submitBtn.innerHTML = origHTML;
            }
          });
      });
    }
  }

  /* Update cart count badge after add-to-cart */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ═══════════════════════════════════════
     QUICK VIEW LINK CLICKS
     [data-wishlist-qv] on JS-built cards
     Falls back to navigation if modal unavailable
     ═══════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var qvLink = e.target.closest('[data-wishlist-qv]');
    if (!qvLink) return;

    e.preventDefault();

    var handle      = qvLink.getAttribute('data-wishlist-qv');
    var fallbackUrl = qvLink.getAttribute('href') || ('/products/' + handle);

    if (handle && window.openQuickView) {
      window.openQuickView(handle);
    } else if (fallbackUrl) {
      window.location.href = fallbackUrl;
    }
  });

  /* ═══════════════════════════════════════
     CROSS-TAB SYNC
     ═══════════════════════════════════════ */
  window.addEventListener('storage', function (e) {
    if (e.key !== STORAGE_KEY) return;
    initButtons();
    if (document.getElementById('wishlistGrid')) {
      renderWishlistPage();
    }
  });

  /* ═══════════════════════════════════════
     MUTATION OBSERVER
     ═══════════════════════════════════════ */
  var moTimer = null;
  var mo = new MutationObserver(function (mutations) {
    var found = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType !== 1) continue;
        if (added[j].classList && added[j].classList.contains('wishlist-toggle')) { found = true; break; }
        if (added[j].querySelector && added[j].querySelector('.wishlist-toggle')) { found = true; break; }
      }
      if (found) break;
    }
    if (found) {
      clearTimeout(moTimer);
      moTimer = setTimeout(initButtons, 50);
    }
  });

  /* ═══════════════════════════════════════
     WISHLIST PAGE — PRODUCT FETCHING
     ═══════════════════════════════════════ */
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Not found: ' + handle);
        return res.json();
      });
  }

  function buildCardHTML(product) {
    var badge = '';
    if (product.tags && product.tags.length) {
      for (var i = 0; i < product.tags.length; i++) {
        if (product.tags[i] === 'badge:limited-edition') { badge = 'Limited Edition'; break; }
        if (product.tags[i] === 'badge:bestseller')      { badge = 'Bestseller'; break; }
        if (product.tags[i] === 'badge:new-arrival')      { badge = 'New Arrival'; break; }
      }
    }

    var category = product.type || '';
    if (product.tags && product.tags.length) {
      for (var i = 0; i < product.tags.length; i++) {
        if (product.tags[i].indexOf('franchise:') === 0) {
          category = product.tags[i].replace('franchise:', '').replace(/-/g, ' ');
          category = category.charAt(0).toUpperCase() + category.slice(1);
          break;
        }
      }
    }

    var priceHTML = 'From ' + formatMoney(product.price);
    if (product.compare_at_price && product.compare_at_price > product.price) {
      priceHTML = '<s style="opacity:0.5;margin-right:6px;">' + formatMoney(product.compare_at_price) + '</s> From ' + formatMoney(product.price);
    }

    var productUrl = product.url || ('/products/' + product.handle);
    if (productUrl.indexOf('/') !== 0) productUrl = '/' + productUrl;

    var html = '';
    html += '<div class="product-card" data-product-id="' + product.id + '" data-product-url="' + productUrl + '">';
    html += '  <div class="card-media">';
    html += '    <div class="card-media-bg"></div>';

    if (badge) {
      html += '    <span class="card-badge">' + badge + '</span>';
    }

    /* Wishlist button */
    html += '    <button class="wishlist-toggle card-wishlist is-active" aria-label="Remove from wishlist" data-wishlist-handle="' + product.handle + '" type="button">';
    html += '      <svg class="wishlist-heart-icon" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
    html += '    </button>';

    /* Product image */
    html += '    <div class="card-svg-wrap">';
    if (product.featured_image) {
      html += '      <img src="' + product.featured_image + '" alt="' + escapeHTML(product.title || '') + '" width="200" height="267" loading="lazy">';
    } else {
      html += '      <svg width="92" height="210" viewBox="0 0 70 210" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="20" y="20" width="30" height="170" rx="2" fill="#3a3a3a" opacity="0.3"/><circle cx="35" cy="105" r="15" fill="#a8a8a8" opacity="0.2"/></svg>';
    }
    html += '    </div>';

    /* Quick View — uses data-wishlist-qv so our handler owns it,
       NOT data-quickview which collection.js owns */
    html += '    <a href="' + productUrl + '" class="card-quickview" data-wishlist-qv="' + product.handle + '">Quick View</a>';
    html += '  </div>';

    html += '  <div class="card-info">';
    if (category) {
      html += '    <p class="card-category">' + escapeHTML(category) + '</p>';
    }
    html += '    <h3 class="card-name">' + escapeHTML(product.title || 'Untitled') + '</h3>';
    html += '    <div class="card-price-row">';
    html += '      <span class="card-price">' + priceHTML + '</span>';
    html += '      <div class="card-stars"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>';
    html += '    </div>';
    html += '  </div>';
    html += '</div>';

    return html;
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ═══════════════════════════════════════
     WISHLIST PAGE — RENDER
     ═══════════════════════════════════════ */
  function renderWishlistPage() {
    var grid       = document.getElementById('wishlistGrid');
    var emptyState = document.getElementById('wishlistEmpty');
    var loadingEl  = document.getElementById('wishlistLoading');
    var countEl    = document.getElementById('wishlistCount');
    var shareEl    = document.getElementById('wishlistShare');
    var clearBtn   = document.getElementById('wishlistClear');

    if (!grid) return;

    var urlParams   = new URLSearchParams(window.location.search);
    var sharedItems = urlParams.get('items');
    var handles     = sharedItems
      ? sharedItems.split(',').filter(function (h) { return h.length > 0; })
      : Store.get();

    if (countEl) {
      countEl.textContent = handles.length + (handles.length === 1 ? ' piece' : ' pieces');
    }

    if (clearBtn) {
      clearBtn.style.display = sharedItems ? 'none' : '';
    }

    if (handles.length === 0) {
      grid.innerHTML = '';
      if (loadingEl)  loadingEl.classList.remove('is-visible');
      if (emptyState) emptyState.classList.add('is-visible');
      if (shareEl)    shareEl.classList.remove('is-visible');
      return;
    }

    if (emptyState) emptyState.classList.remove('is-visible');
    if (loadingEl)  loadingEl.classList.add('is-visible');
    if (shareEl)    shareEl.classList.remove('is-visible');

    var fetches = handles.map(function (handle) {
      return fetchProduct(handle).catch(function () { return null; });
    });

    Promise.all(fetches).then(function (products) {
      if (loadingEl) loadingEl.classList.remove('is-visible');

      grid.innerHTML = '';

      var validProducts = products.filter(function (p) { return p !== null; });

      if (!sharedItems) {
        var validHandles = validProducts.map(function (p) { return p.handle; });
        var current      = Store.get();
        var changed      = false;
        var updated      = current.filter(function (h) {
          if (validHandles.indexOf(h) === -1) { changed = true; return false; }
          return true;
        });
        if (changed) { Store.save(updated); updateBadge(); }
      }

      if (validProducts.length === 0) {
        if (emptyState) emptyState.classList.add('is-visible');
        if (shareEl)    shareEl.classList.remove('is-visible');
        if (countEl)    countEl.textContent = '0 pieces';
        return;
      }

      validProducts.forEach(function (product, index) {
        var temp = document.createElement('div');
        temp.innerHTML = buildCardHTML(product);
        var card = temp.firstChild;
        card.style.animationDelay = (index * 0.05) + 's';
        grid.appendChild(card);
      });

      if (shareEl) shareEl.classList.add('is-visible');
      initButtons();

    }).catch(function (err) {
      console.error('[SmithsWishlist] Render error:', err);
      if (loadingEl) loadingEl.classList.remove('is-visible');
    });
  }

  /* ═══════════════════════════════════════
     WISHLIST PAGE — EMPTY CHECK
     ═══════════════════════════════════════ */
  function checkWishlistEmpty() {
    var grid       = document.getElementById('wishlistGrid');
    var emptyState = document.getElementById('wishlistEmpty');
    var countEl    = document.getElementById('wishlistCount');
    var shareEl    = document.getElementById('wishlistShare');

    if (!grid) return;

    var remaining = grid.querySelectorAll('.product-card:not(.is-removing)');
    if (remaining.length === 0) {
      if (emptyState) emptyState.classList.add('is-visible');
      if (shareEl)    shareEl.classList.remove('is-visible');
    }

    var count = Store.count();
    if (countEl) countEl.textContent = count + (count === 1 ? ' piece' : ' pieces');
  }

  /* ═══════════════════════════════════════
     WISHLIST PAGE — CLEAR ALL
     ═══════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var clearBtn = e.target.closest('#wishlistClear');
    if (!clearBtn) return;
    Store.clear();
    updateBadge();
    initButtons();
    renderWishlistPage();
    showNotification('Wishlist cleared', true);
  });

  /* ═══════════════════════════════════════
     WISHLIST PAGE — SHARE
     ═══════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var shareBtn = e.target.closest('#wishlistShareBtn');
    if (!shareBtn) return;

    var handles = Store.get();
    var url     = window.location.origin + '/pages/wishlist?items=' + handles.join(',');

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        showNotification('Link copied to clipboard', false);
      }).catch(fallbackCopy);
    } else {
      fallbackCopy();
    }

    function fallbackCopy() {
      var input = document.createElement('input');
      input.value = url;
      input.style.position = 'fixed';
      input.style.opacity  = '0';
      document.body.appendChild(input);
      input.select();
      try { document.execCommand('copy'); showNotification('Link copied to clipboard', false); } catch (e) { /* ignore */ }
      document.body.removeChild(input);
    }
  });

  /* ═══════════════════════════════════════
     INIT
     ═══════════════════════════════════════ */
  function init() {
    migrateStorage();
    initButtons();
    initQuickViewSupport();
    mo.observe(document.body, { childList: true, subtree: true });
    if (document.getElementById('wishlistGrid')) {
      renderWishlistPage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ═══════════════════════════════════════
     PUBLIC API
     ═══════════════════════════════════════ */
  window.SmithsWishlist = Store;

})();